export default "__VITE_ASSET__BkUn8Je4__"